const catchAsyncError = (error: any): string => {
  return error.message;
};

export default catchAsyncError;
